module.exports = __webpack_public_path__ + "78ad9b1f52ef72ad284b5cc10c4c5ee3.svg";